import axiosInstance from '../axiosInstance';
import { endpoints } from '../endPoints';

const base = endpoints.tenantServiceAssignments.base;

function tenantHeaders(registryTenantId) {
  if (!registryTenantId) return {};
  return { 'X-TenantID': String(registryTenantId).trim() };
}

export async function fetchTenantAssignmentsWithServices(tenantId) {
  const url = endpoints.tenantServiceAssignments.byTenantWithServices(tenantId);
  const res = await axiosInstance.get(url, { headers: tenantHeaders(tenantId) });
  return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function assignTenantService(tenantId, serviceId) {
  const res = await axiosInstance.post(
    base,
    { tenantId, serviceId },
    { headers: tenantHeaders(tenantId) }
  );
  return res.data?.data ?? res.data;
}

export async function unassignTenantService(tenantId, serviceId) {
  await axiosInstance.delete(base, {
    params: { tenantId, serviceId },
    headers: tenantHeaders(tenantId),
  });
}

/** Large page for select options (assign dialog). */
export async function fetchServiceCatalogRows(page = 0, size = 500, registryTenantId = null) {
  const res = await axiosInstance.get(
    `${endpoints.serviceCatalog.base}?page=${page}&size=${size}`,
    { headers: tenantHeaders(registryTenantId) }
  );
  const rec = res.data?.data;
  return Array.isArray(rec?.data) ? rec.data : [];
}
